// extracted by mini-css-extract-plugin
module.exports =  {"root":"rATTBIs1TxCrmHslJLgb","horizontal":"XuVupb5flufJJPtaOkHi","vertical":"SNYCBSD0FSjQwV1wHAP3","speechBubble":"BLtKlVw7kP7uDdNvruBD","mascotImage":"bf6zBiC98koiMFmaR4sT"};